import React from 'react';
import JQuery from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import { Draggable } from 'react-beautiful-dnd';
import { appDispatch, RootState } from 'store/store';
import { getRandomInt, convertDigitToProperFormat } from 'utils/number';
import Icon from 'components/Icon';
import Button from 'components/Button';
import messages from './Messages';
import IconTypes from 'components/Icon/IconTypes';
import ActionLink from 'components/ActionLink';
import { display } from 'components/ErrorView/ErrorDialog';
import GeneralQuestionViewer from './GeneralQuestion/GeneralQuestionViewer';
import GeneralQuestionEditor from './GeneralQuestion';
import {
  SubmitForm,
  FormContainer,
  QuestionIcon,
  IndexOrderBadge,
} from './styles';
import { connect, MapStateToProps } from 'react-redux';
import { getAccessToken } from 'api/Utils';
import {
  black,
  exactWhite,
  gray,
  green,
  lightRedSolid,
  red,
} from 'utils/style/colors';
import { setClipboard } from 'containers/Tasks/TasksManagement/TaskUtils';
import notify from '../../../../Notify';
import APopover from '../../../../APopover';
import Select from '../../../../Select';
import { IOption } from 'components/Select/Select';
import {
  IFormValues,
  IQuestionTags,
  ISurveyItem,
  ISurveyView,
  QuestionState,
} from 'store/survey/surveyTypes';
import { ICompany } from 'store/companies/companiesTypes';
import {
  addQuestionAction,
  changeQuestionState,
  updateQuestion,
  // updateQuestionAction,
} from 'store/survey/surveySlice';
import {
  isAdvanceAdmin,
  isCompanyOwnerOrSupport,
} from '../../../../../store/companies/companiesUtils';
import i18n, { languageDirection } from '../../../../../i18n';

const $: any = JQuery;

interface IStateToProps {
  survey: ISurveyView;
  companyRoles?: ICompany['roles'];
  token: string;
  hospitalTagId?: number;
  isOwnerOrSupport?: boolean;
  userIsAdvanceAdmin?: boolean;
}

interface IOwnProps {
  icon: IconTypes;
  tags: IQuestionTags;
  index: number;
  child: (editing: boolean) => React.ReactNode;
  dispatch: typeof appDispatch;
  surveyId: number;
  question: {
    data: IFormValues['data'];
    state: QuestionState;
  };
  secondaryQuestion?: {
    data: IFormValues['data'];
    state: QuestionState;
  };
  providerSurvey: { data: ISurveyItem };
  secondaryProviderSurvey?: ISurveyItem;
  displayDeleted: boolean;
  questionTitleLabel?: string;
  readOnly?: boolean;
  onRemoveQuestion?: (questionId: number) => void;
  questionState?: {
    editing: boolean;
    loading: boolean;
  };
  changeQuestionState?: (
    questionId: number,
    questionState: { editing?: boolean; loading?: boolean }
  ) => void;
}

type IComponentProps = IOwnProps & IStateToProps;

class QuestionViewer extends React.Component<IComponentProps> {
  state = {
    disableLoading: new Set<number>(),
    copyQuestionTitles: [] as IOption[],
  };

  ulList: any;

  componentDidMount() {
    $('.collapsible').collapsible();
    this.props.changeQuestionState?.(this.props.question.data.id, {
      loading: false,
      editing: this.props.question.state === 'creating',
    });
  }
  componentDidUpdate(prevProps: Readonly<IComponentProps>) {
    $('.collapsible').collapsible();
    if (
      this.props.question.state === 'editing' &&
      !this.props.questionState?.editing &&
      prevProps.question.state !== 'editing'
    ) {
      this.props.changeQuestionState?.(this.props.question.data.id, {
        editing: true,
      });
    }
  }

  onChangeDeleted = (deleted: boolean) => (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      let {
        question: { data: questionData },
      } = this.props;
      const { displayDeleted, providerSurvey } = this.props;
      questionData = {
        ...cloneDeep(questionData),
        deleted: deleted,
      };
      if (deleted && !displayDeleted) {
        $(this.ulList).slideUp({
          done: () => {
            appDispatch(
              updateQuestion({
                questionData,
                providerSurveyData: providerSurvey.data,
              })
            ).catch((err: any) => {
              $(this.ulList).slideDown();
              display(err);
            });
          },
        });
        return;
      }
      appDispatch(
        updateQuestion({
          questionData,
          providerSurveyData: providerSurvey.data,
        })
      );
    }
  };

  handleChangeQuestionState = (questionState: QuestionState) => () => {
    const { question, providerSurvey } = this.props;
    this.props.onRemoveQuestion?.(question.data.id);
    appDispatch(
      changeQuestionState({
        questionId: question.data.id,
        surveyId: providerSurvey.data.surveyId,
        state: questionState,
      })
    );
  };

  handleAddToClipboard = () => {
    const { question, surveyId } = this.props;
    if (navigator.clipboard && navigator.clipboard.readText) {
      navigator.clipboard
        .readText()
        .then((s) => {
          let current: any[] = [];
          try {
            const currentJson = JSON.parse(s);
            if (currentJson.type === 'question')
              current = (currentJson.value as any[]) || [];
          } catch (e) {
            /*do nothing*/
          }
          setClipboard(
            JSON.stringify({
              type: 'question',
              surveyId: surveyId,
              value: [...current, question.data],
            })
          );
          notify(messages.questionCopied(current.length + 1));
        })
        .catch(() => {
          setClipboard(
            JSON.stringify({
              type: 'question',
              surveyId: surveyId,
              value: [question.data],
            })
          );
          notify(messages.questionCopied(1));
        });
    } else {
      setClipboard(
        JSON.stringify({
          type: 'question',
          surveyId: surveyId,
          value: [question.data],
        })
      );
      notify(messages.questionCopied(1));
    }
  };
  handleSetClipboard = () => {
    const { question, surveyId } = this.props;
    const current: any[] = [];
    setClipboard(
      JSON.stringify({
        type: 'question',
        surveyId: surveyId,
        value: [...current, question.data],
      })
    );
    notify(messages.questionCopied(1));
  };
  handleCopyQuestion = () => {
    const { question, surveyId } = this.props;
    let order = question.data.order;
    this.state.copyQuestionTitles.forEach((item) => {
      const title = item.value.toString();
      const questionCopy = cloneDeep(question.data);
      questionCopy.id = getRandomInt(1, 1000);
      questionCopy.title = title;
      questionCopy.order = order + Math.random() / 10;
      order = questionCopy.order;
      appDispatch(
        addQuestionAction({
          surveyId,
          question: questionCopy,
        })
      );
    });
  };
  handleCopyLinkToQuestion = () => {
    const { question } = this.props;
    navigator.clipboard.writeText(`%a:${question.data.id}%`);
  };

  render() {
    const {
      icon,
      tags,
      index,
      child,
      question,
      questionTitleLabel,
      survey,
      readOnly,
      companyRoles,
      token,
      isOwnerOrSupport,
      userIsAdvanceAdmin,
      questionState,
    } = this.props;
    // if (question.data.indexOrder! - 1 != index)
    const currentVersion = survey.currentVersion;
    const indexOrder = survey.versions?.[currentVersion]?.questionList?.find(
      (item) => item.id === question.data.id
    )?.indexOrder;

    if (question.state === 'creating' || questionState?.editing) {
      return (
        <li
          className="white collection-item valign-wrapper "
          style={{
            display: 'block',
            borderBottom: '1px solid black',
          }}
        >
          <div className="row no-margin w" style={{ background: exactWhite }}>
            <FormContainer>
              <GeneralQuestionEditor
                tags={tags}
                icon={icon}
                questionTitleLabel={questionTitleLabel}
                otherQuestions={survey.questionMap!}
                companyRoles={companyRoles!}
                token={token}
                survey={survey}
                isOwnerOrSupport={isOwnerOrSupport}
                userIsAdvanceAdmin={userIsAdvanceAdmin}
              >
                {child(true)}
              </GeneralQuestionEditor>
              <SubmitForm className="col s12">
                <Button
                  type="submit"
                  color="green"
                  loading={questionState?.loading}
                >
                  {i18n.t('confirm', { ns: 'survey' }) as string}
                </Button>
                {question.state === 'creating' ? (
                  <Button
                    color="red"
                    onClick={() => {
                      this.props.changeQuestionState?.(question.data.id, {
                        editing: false,
                      });
                      this.handleChangeQuestionState('removed')();
                    }}
                  >
                    {question.data?.modificationType === 'deleted'
                      ? (i18n.t('cancel', { ns: 'survey' }) as string)
                      : (i18n.t('delete', { ns: 'survey' }) as string)}
                  </Button>
                ) : (
                  <Button
                    color="red"
                    onClick={() => {
                      this.props.onRemoveQuestion?.(question.data.id);
                      this.props.changeQuestionState?.(question.data.id, {
                        editing: false,
                      });
                    }}
                  >
                    {i18n.t('cancel', { ns: 'survey' }) as string}
                  </Button>
                )}
              </SubmitForm>
            </FormContainer>
          </div>
        </li>
      );
    }

    const dir = languageDirection() === 'rtl' ? 'left' : 'right';

    return (
      <Draggable draggableId={question.data.id.toString()} index={index}>
        {(provided) => {
          const style = {
            backgroundColor: 'var(--exact-white)',
            padding: 'none !important',
            ...provided.draggableProps.style,
          };
          return (
            <ul
              className="collapsible"
              data-collapsible="accordion"
              style={{
                margin: 0,
                border: 'none',
                boxShadow: 'none',
              }}
              ref={(el) => {
                this.ulList = el;
              }}
            >
              <li
                {...provided.draggableProps}
                ref={provided.innerRef}
                style={style}
                className="hover-area"
              >
                <div
                  className="collapsible-header py-5"
                  style={{
                    justifyContent: 'space-between',
                    position: 'sticky',
                    background: question.data.deleted
                      ? lightRedSolid
                      : exactWhite,
                  }}
                >
                  <span className="valign-wrapper" style={{ width: '100%' }}>
                    {question.state === 'uploading' ? (
                      <div
                        className="preloader-wrapper small active"
                        style={{ marginInlineStart: '.5em' }}
                      >
                        <div className="spinner-layer spinner-green-only">
                          <div className="circle-clipper left">
                            <div className="circle" />
                          </div>
                          <div className="gap-patch">
                            <div className="circle" />
                          </div>
                          <div className="circle-clipper right">
                            <div className="circle" />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <IndexOrderBadge>
                          {convertDigitToProperFormat(indexOrder || '-')}
                        </IndexOrderBadge>
                        <QuestionIcon
                          type={icon}
                          deleted={question.data.deleted}
                        />
                      </>
                    )}
                    <p
                      className="multi-line no-margin"
                      style={{
                        width: 'calc(100% - 3rem)',
                        color: question.data.disabled ? gray : black,
                        textDecoration: question.data.disabled
                          ? 'line-through'
                          : undefined,
                      }}
                    >
                      {question.data.title}{' '}
                      {question.data.disabled
                        ? ' - ' + i18n.t('disabled', { ns: 'survey' })
                        : ''}
                    </p>
                  </span>
                  {!readOnly ? (
                    <span
                      className="visible-on-hover"
                      style={{ position: 'absolute', [dir]: '0', top: '12px' }}
                    >
                      <span style={{ display: 'flex' }}>
                        <ActionLink
                          {...provided.dragHandleProps}
                          color="black"
                          data-delay="50"
                          data-tooltip={i18n.t('drag', { ns: 'survey' })}
                          title={question.data.order.toString()}
                        >
                          <Icon type="move" />
                        </ActionLink>
                        {!question.data.deleted && (
                          <APopover
                            placement={'bottom'}
                            curveBorder
                            arrow
                            target={
                              <ActionLink
                                color="black"
                                data-delay="50"
                                data-tooltip={i18n.t('copying', {
                                  ns: 'survey',
                                })}
                              >
                                <Icon type="copy" />
                              </ActionLink>
                            }
                          >
                            <div>
                              <h6>
                                {
                                  i18n.t('copyQuestion', {
                                    ns: 'survey',
                                  }) as string
                                }
                              </h6>
                              <Select
                                containerStyle={{ width: '400px' }}
                                values={this.state.copyQuestionTitles}
                                letAddChip
                                onChangeValues={(values) => {
                                  this.setState({ copyQuestionTitles: values });
                                }}
                                multiChoice={true}
                                placeholder={i18n.t('enterQuestionTitle', {
                                  ns: 'survey',
                                })}
                                options={[]}
                              />
                              <div style={{ display: 'flex' }}>
                                <Button
                                  color="black"
                                  disabled={
                                    this.state.copyQuestionTitles.length === 0
                                  }
                                  onClick={this.handleCopyQuestion}
                                >
                                  {
                                    i18n.t('createCopy', {
                                      ns: 'survey',
                                    }) as string
                                  }
                                </Button>
                                <span style={{ flexGrow: 1 }}></span>

                                <Button onClick={this.handleSetClipboard}>
                                  {
                                    i18n.t('copyToClipboard', {
                                      ns: 'survey',
                                    }) as string
                                  }
                                </Button>
                                <Button onClick={this.handleAddToClipboard}>
                                  {
                                    i18n.t('addToClibpard', {
                                      ns: 'survey',
                                    }) as string
                                  }
                                </Button>
                              </div>
                            </div>
                          </APopover>
                        )}
                        <ActionLink
                          color="black"
                          onClick={() => {
                            this.props.changeQuestionState?.(question.data.id, {
                              editing: true,
                            });
                          }}
                          data-delay="50"
                          data-tooltip={
                            i18n.t('edit', {
                              ns: 'survey',
                            }) as string
                          }
                        >
                          <Icon type="edit" />
                        </ActionLink>
                        {!question.data.deleted ? (
                          <ActionLink
                            color="black"
                            data-delay="50"
                            onClick={this.onChangeDeleted(true)}
                            data-tooltip={
                              i18n.t('delete', {
                                ns: 'survey',
                              }) as string
                            }
                          >
                            <Icon type="trash-2" color={red} />
                          </ActionLink>
                        ) : (
                          <ActionLink
                            color="black"
                            onClick={this.onChangeDeleted(false)}
                            data-delay="50"
                            data-tooltip={
                              i18n.t('restoreQuestion', {
                                ns: 'survey',
                              }) as string
                            }
                          >
                            <Icon type="rotate-ccw" color={green} />
                          </ActionLink>
                        )}
                      </span>
                    </span>
                  ) : (
                    <div
                      {...provided.dragHandleProps}
                      style={{ display: 'none' }}
                    />
                  )}
                </div>
                <div
                  className="collapsible-body"
                  style={{ overflow: 'hidden', padding: '0px 0.5em' }}
                >
                  <GeneralQuestionViewer
                    hint={question.data.hint}
                    type={question.data.type}
                    distinctive={question.data.distinctive}
                    answerRequired={question.data.answerRequired}
                    survey={survey}
                  />
                  {child(false)}
                </div>
              </li>
            </ul>
          );
        }}
      </Draggable>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const survey = state.survey.data[props.surveyId].data;
  const providerId = props.providerSurvey.data.providerId;
  const provider = state.providers.map[providerId];
  const companyId = provider.data?.managingCompanyId;
  const companyRoles = state.companies.data[companyId!]?.roles;
  const hospitalTagIdTmp = props.secondaryProviderSurvey?.providerId
    ? Object.values(
        state.providers.tags[props.secondaryProviderSurvey.providerId]?.data ||
          {}
      )?.find((it) => it.text === 'بیمارستان')?.id
    : undefined;
  let company: ICompany | undefined = undefined;
  if (companyId) company = state.companies.data[companyId];
  const thisUser = state.thisUser;
  const isOwnerOrSupport =
    Boolean(
      Number(thisUser.userId) === state.providers.map[providerId]?.data?.user
    ) || Boolean(company && isCompanyOwnerOrSupport(thisUser, company));
  const userIsAdvanceAdmin = company && isAdvanceAdmin(thisUser, company);
  const hospitalTagId = hospitalTagIdTmp ? Number(hospitalTagIdTmp) : undefined;

  const token = getAccessToken(state)!;
  return {
    survey,
    companyRoles: companyRoles ? Object.values(companyRoles) : undefined,
    token,
    hospitalTagId,
    isOwnerOrSupport,
    userIsAdvanceAdmin,
  };
};

export default connect(mapStateToProps)(QuestionViewer);
